import { navigate } from "@reach/router";

export async function initiateRazorpay(amount, courseId, checkoutObj) {
  function onFailure(rzpResponse) {
    navigate("/checkout-status", {
      state: {
        rzpResponse: rzpResponse,
        status: "failure",
        courseId: courseId,
        checkoutId: checkoutObj.id,
      },
    });
  }

  function onSuccess(rzpResponse) {
    navigate("/checkout-status", {
      state: {
        rzpResponse: rzpResponse,
        status: "success",
        courseId: courseId,
        checkoutId: checkoutObj.id,
      },
    });
  }

  const razorpayOptions = {
    key: process.env.REACT_APP_RAZORPAY_KEY,
    amount: amount,
    currency: "INR",
    order_id: checkoutObj.gatewayReference,
    modal: {
      ondismiss: onFailure,
    },
    handler: onSuccess,
  };

  const razorpayWindow = new window["Razorpay"](razorpayOptions);
  // razorpayWindow.on("payment.failed", function (response) {
  //   console.log(response);
  // });
  razorpayWindow.open();
}
